"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceBreakpoints = exports.getStringDeviceBreakpoints = void 0;
var styled_components_1 = require("styled-components");
var consts_1 = require("../../components/Sidebar/consts");
var MENU_STATE_DIFFERENCE_WIDTH = consts_1.MENU_OPENED_WIDTH - consts_1.MENU_CLOSED_WIDTH;
var getStringDeviceBreakpoints = function (deviceBreakpoints, isSidebarOpen) {
    return deviceBreakpoints.reduce(function (all, item) {
        var _a;
        var sidebarReduction = isSidebarOpen && !item.device.includes('mobile') ? MENU_STATE_DIFFERENCE_WIDTH : 0;
        var min = item.minWidth + sidebarReduction;
        var max = item.maxWidth + sidebarReduction;
        return __assign(__assign({}, all), (_a = {}, _a[item.device] = {
            only: "screen and (min-width: ".concat(min, "px) and (max-width: ").concat(max, "px)"),
            landscape: "screen and (min-width: ".concat(min, "px) and (max-width: ").concat(max, "px) and (orientation: Landscape)"),
            portrait: "screen and (min-width: ".concat(min, "px) and (max-width: ").concat(max, "px) and (orientation: Portrait)"),
            min: "screen and (min-width: ".concat(min, "px)"),
            max: "screen and (max-width: ".concat(max, "px)"),
            minIgnoreSidebar: "screen and (min-width: ".concat(min - sidebarReduction, "px)"),
        }, _a));
    }, {});
};
exports.getStringDeviceBreakpoints = getStringDeviceBreakpoints;
var getDeviceBreakpoints = function (deviceBreakpoints, isSidebarOpen) {
    var stringDeviceBreakpoints = (0, exports.getStringDeviceBreakpoints)(deviceBreakpoints, isSidebarOpen);
    return deviceBreakpoints.reduce(function (all, item) {
        var _a;
        return (__assign(__assign({}, all), (_a = {}, _a[item.device] = Object.entries(stringDeviceBreakpoints[item.device]).reduce(function (innerAll, _a) {
            var _b;
            var filter = _a[0], mediaQuery = _a[1];
            return (__assign(__assign({}, innerAll), (_b = {}, _b[filter] = function (style) { return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            @media ", " {\n              ", "\n            }\n          "], ["\n            @media ", " {\n              ", "\n            }\n          "])), mediaQuery, style); }, _b)));
        }, {}), _a)));
    }, {});
};
exports.getDeviceBreakpoints = getDeviceBreakpoints;
var templateObject_1;
